/* ==========================================================================
   Zornits — Amazon-style rating badge
   Enhances Judge.me's existing .jdgm-prev-badge in place:
     4.6  ★★★★☆ ▾  (5)      + hover/tap breakdown

   Adds nothing to the page until Judge.me has rendered a badge, and re-applies
   itself if Judge.me re-renders. Histogram is fetched from Judge.me's public
   widget endpoint on first open and cached for the session.

   PUBLIC token only — this is the same token Judge.me already exposes in the
   storefront. Never put the private token in a theme file.
   ========================================================================== */
(function () {
  "use strict";

  var PUBLIC_TOKEN = "i_aN7Mbu0smeB3VeIsPmIsIdJ3Q";
  var SHOP_DOMAIN = "zornits.myshopify.com";
  var REVIEWS_ANCHOR = "#judgeme_product_reviews";

  var pop = null;
  var openFor = null;
  var closeTimer = null;

  // ---------------------------------------------------------------- helpers
  function oneDp(n) {
    return (Math.round(n * 10) / 10).toFixed(1);
  }

  function starsMarkup(rating) {
    var out = "";
    for (var i = 1; i <= 5; i++) {
      var rem = rating - (i - 1);
      var cls = rem >= 0.75 ? "jdgm--on" : (rem >= 0.25 ? "jdgm--half" : "jdgm--off");
      out += "<span class='jdgm-star " + cls + "'></span>";
    }
    return out;
  }

  /* The handle of the product this badge belongs to: the nearest product link
     on a card, or the current URL on a product page. */
  function handleFor(badge) {
    var link = badge.closest("a[href*='/products/']");
    if (!link) {
      /* Walk up until an ancestor actually contains a product link. Matching on
         a class name is not safe here: the badge's own wrapper is
         .m-product-card__reviews, which matches [class*='product-card'] but
         holds no link. */
      var el = badge;
      for (var i = 0; i < 8 && el; i++) {
        var found = el.querySelector && el.querySelector("a[href*='/products/']");
        if (found) { link = found; break; }
        el = el.parentElement;
      }
    }
    var href = link ? link.getAttribute("href") : window.location.pathname;
    var m = (href || "").match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function reviewsHref(badge) {
    var handle = handleFor(badge);
    var onPdp = window.location.pathname.indexOf("/products/") !== -1;
    if (onPdp || !handle) return REVIEWS_ANCHOR;
    return "/products/" + handle + REVIEWS_ANCHOR;
  }

  // ------------------------------------------------------------- enhance
  function enhance(badge) {
    if (badge.hasAttribute("data-zn")) return;

    var rating = parseFloat(badge.getAttribute("data-average-rating"));
    var count = parseInt(badge.getAttribute("data-number-of-reviews"), 10);
    if (!isFinite(rating) || !isFinite(count) || count <= 0) return; // nothing to show

    var stars = badge.querySelector(".jdgm-prev-badge__stars");
    if (!stars) return;

    badge.setAttribute("data-zn", "");

    var num = document.createElement("span");
    num.className = "zn-num";
    num.textContent = oneDp(rating);

    var caret = document.createElement("span");
    caret.className = "zn-caret";
    caret.setAttribute("aria-hidden", "true");

    var trigger = document.createElement("span");
    trigger.className = "zn-trigger";
    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-label",
      oneDp(rating) + " out of 5 stars, " + count + (count === 1 ? " review" : " reviews") +
      ". Show rating breakdown.");
    stars.parentNode.insertBefore(trigger, stars);
    trigger.appendChild(num);
    trigger.appendChild(stars);
    trigger.appendChild(caret);

    var count_a = document.createElement("a");
    count_a.className = "zn-count";
    count_a.href = reviewsHref(badge);
    count_a.textContent = "(" + count + ")";
    trigger.parentNode.insertBefore(count_a, trigger.nextSibling);
  }

  function enhanceAll() {
    var nodes = document.querySelectorAll(".jdgm-prev-badge:not([data-zn])");
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);
  }

  // ------------------------------------------------------------- popover
  function ensurePop() {
    if (pop) return pop;
    pop = document.createElement("div");
    pop.className = "zn-pop";
    pop.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    pop.addEventListener("mouseleave", scheduleClose);
    document.body.appendChild(pop);
    return pop;
  }

  var cache = {};

  function histogram(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    try {
      var stored = sessionStorage.getItem("zn-hist-" + handle);
      if (stored) { cache[handle] = JSON.parse(stored); return Promise.resolve(cache[handle]); }
    } catch (e) { /* private mode: just skip the cache */ }

    var url = "https://judge.me/api/v1/widgets/product_review?api_token=" +
      encodeURIComponent(PUBLIC_TOKEN) + "&shop_domain=" + encodeURIComponent(SHOP_DOMAIN) +
      "&handle=" + encodeURIComponent(handle);

    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var doc = new DOMParser().parseFromString(d.widget || "", "text/html");
        var rows = doc.querySelectorAll(".jdgm-histogram__row");
        var dist = [];
        for (var i = 0; i < rows.length; i++) {
          /* the widget also carries a "clear filter" row with no data-rating */
          var stars = parseInt(rows[i].getAttribute("data-rating"), 10);
          if (!(stars >= 1 && stars <= 5)) continue;
          dist.push({
            rating: stars,
            pct: parseInt(rows[i].getAttribute("data-percentage"), 10) || 0
          });
        }
        dist.sort(function (a, b) { return b.rating - a.rating; });
        cache[handle] = dist;
        try { sessionStorage.setItem("zn-hist-" + handle, JSON.stringify(dist)); } catch (e) {}
        return dist;
      })
      .catch(function () { return null; });
  }

  function render(badge, dist) {
    var rating = parseFloat(badge.getAttribute("data-average-rating"));
    var count = parseInt(badge.getAttribute("data-number-of-reviews"), 10);
    var head =
      "<div class='zn-pop__head'><span class='jdgm-prev-badge__stars'>" + starsMarkup(rating) +
      "</span><span class='zn-pop__score'>" + oneDp(rating) + " out of 5</span></div>" +
      "<div class='zn-pop__total'>" + count + (count === 1 ? " review" : " reviews") + "</div>";

    var body;
    if (!dist || !dist.length) {
      body = "<div class='zn-pop__loading'>Rating breakdown unavailable.</div>";
    } else {
      body = dist.map(function (d) {
        return "<div class='zn-pop__row'>" +
          "<span class='zn-pop__star'>" + d.rating + " star</span>" +
          "<span class='zn-pop__track'>" +
          (d.pct ? "<span class='zn-pop__fill' style='width:" + d.pct + "%'></span>" : "") +
          "</span>" +
          "<span class='zn-pop__pct'>" + d.pct + "%</span></div>";
      }).join("");
    }

    var foot = "<div class='zn-pop__foot'><a href='" + reviewsHref(badge) + "'>See all " +
      count + (count === 1 ? " review" : " reviews") + " ›</a></div>";

    ensurePop().innerHTML = head + body + foot;
  }

  function position(badge) {
    var p = ensurePop();
    var r = badge.getBoundingClientRect();
    p.style.left = "0px";
    p.style.top = "0px";
    var w = p.offsetWidth, h = p.offsetHeight;
    var left = Math.min(Math.max(8, r.left - 12), window.innerWidth - w - 8);
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 8);
    p.style.left = left + "px";
    p.style.top = top + "px";
  }

  function open(badge) {
    clearTimeout(closeTimer);
    if (openFor === badge && pop && pop.hasAttribute("data-open")) return;
    openFor = badge;
    var handle = handleFor(badge);
    render(badge, cache[handle] || null);
    if (!cache[handle]) {
      ensurePop().insertAdjacentHTML("beforeend", "");
    }
    ensurePop().setAttribute("data-open", "");
    position(badge);
    if (handle && !cache[handle]) {
      histogram(handle).then(function (dist) {
        if (openFor !== badge) return;
        render(badge, dist);
        position(badge);
      });
    }
  }

  function close() {
    if (pop) pop.removeAttribute("data-open");
    openFor = null;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 180);
  }

  // ------------------------------------------------------------- events
  document.addEventListener("mouseover", function (e) {
    var t = e.target.closest && e.target.closest(".jdgm-prev-badge[data-zn]");
    if (t) open(t);
  });
  document.addEventListener("mouseout", function (e) {
    var t = e.target.closest && e.target.closest(".jdgm-prev-badge[data-zn]");
    if (t && !(e.relatedTarget && pop && pop.contains(e.relatedTarget))) scheduleClose();
  });
  document.addEventListener("focusin", function (e) {
    var t = e.target.closest && e.target.closest(".jdgm-prev-badge[data-zn]");
    if (t) open(t);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
    if ((e.key === "Enter" || e.key === " ") && e.target.classList &&
        e.target.classList.contains("zn-trigger")) {
      e.preventDefault();
      open(e.target.closest(".jdgm-prev-badge"));
    }
  });
  // touch: tap the stars to toggle
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest && e.target.closest(".zn-trigger");
    if (trigger) {
      e.preventDefault();
      var badge = trigger.closest(".jdgm-prev-badge");
      if (openFor === badge && pop && pop.hasAttribute("data-open")) close();
      else open(badge);
      return;
    }
    if (pop && !pop.contains(e.target)) close();
  });
  window.addEventListener("scroll", close, { passive: true });
  window.addEventListener("resize", close);

  // ------------------------------------------------------------- boot
  function boot() {
    enhanceAll();
    // Judge.me renders late and re-renders on filter / infinite scroll
    new MutationObserver(function () { enhanceAll(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
